

/*
function makeChannel(name, url, pan) {
  const channel = new Tone.Channel({
    pan
  }).toDestination();
  const player = new Tone.Player({
    url: `https://tonejs.github.io/audio/berklee/${url}.mp3`,
    loop: true
  }).sync().start(0);
  player.connect(channel);
  return channel;

}

makeChannel("Guitar 0", "comping1", 0);
makeChannel("Guitar 1", "comping2", 0);
makeChannel("Guitar 2", "comping3", 0);
makeChannel("Guitar 3", "comping4", 0);*/

const channel0 = new Tone.Channel().toDestination();
const channel1 = new Tone.Channel().toDestination();
const channel2 = new Tone.Channel().toDestination();

const players = new Tone.Players({
  urls: {
    "0": "/files/Roothuus/stationen/instrumentierung/audio/kontrabass.mp3",
    "1": "/files/Roothuus/stationen/instrumentierung/audio/hackbrett.mp3",
    "2": "/files/Roothuus/stationen/instrumentierung/audio/akkordeon.mp3"
  },
}); //.toDestination();

players.player("0").connect(channel0).sync().start(0);
players.player("1").connect(channel1).sync().start(0);
players.player("2").connect(channel2).sync().start(0);
players.player("0").loop = true;
players.player("1").loop = true;
players.player("2").loop = true;
/*document.querySelector("#testButton").addEventListener("click", async () => {
  await Tone.start();
  if (Tone.Transport.state === "started") {
//    Tone.Transport.stop();
    channel0.mute = 1;
    channel1.mute = 1;
  } else {
    Tone.Transport.start();
  }
});
document.querySelector("#mute1").addEventListener("click", async () => {
  if(channel0.mute == 1) {
    channel0.mute = 0;
  } else {
    channel0.mute = 1;
  }
});

document.querySelector("#mute2").addEventListener("click", async () => {
  if(channel1.mute == 1) {
    channel1.mute = 0;
  } else {
    channel1.mute = 1;
  }
});

document.querySelector("#mute3").addEventListener("click", async () => {
  if(channel2.mute == 1) {
    channel2.mute = 0;
  } else {
    channel2.mute = 1;
  }
});*/




// Native browser hash navigation handles initial scroll instantly. No JS scroll needed.

$(document).ready(function(){


  let widthDif = window.innerWidth - document.documentElement.scrollWidth;


  if($(window).width() <= 1074 ) {
    $(".mobile-navigation").addClass("mobile-size");
  }else {
    $(".mobile-navigation").addClass("desktop-size");
  }

  if(widthDif > 0) {
    $(".sw-nav .hover_background").toggleClass("has-scrollbar")
  }




  const bodyScrollLock = require('body-scroll-lock');
  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;
  const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;

  let timerService = null;

  function getBootstrapBreakpoint(){
    var w = $(document).innerWidth();
    return (w < 768) ? 'xs' : ((w < 992) ? 'sm' : ((w < 1200) ? 'md' : 'lg'));
  }

  $(".sw-nav").hover(function() {
    if($(this).hasClass("anchor-link")) return;
    if(!$(".sw-nav .hover_background").hasClass("menu_hovered")) {
      if(!$(".sw-nav .hover_background").hasClass("anchor-link-active")){
        $("html, body").animate({ scrollTop: "0" });
      }
      // disableBodyScroll();
      $(".hover_close_clicked").toggleClass("hover_close_clicked")
      $(".sw-nav .hover_background").stop().slideDown(500);
      $(".sw-nav .hover_background").toggleClass("menu_hovered")
      $(".sw-nav .level_1 .active").toggleClass("menu_open")
      $(".header-audio-player").toggleClass("hide-player")
      $(".submenu.trail").toggleClass("menu_open")
    }
  }, function() {
    if($(this).hasClass("anchor-link")) return;
    $(".active_parentmenu").toggleClass("active_parentmenu")
    if($(".sw-nav .level_1 .active").hasClass("menu_open")) {
      $(".sw-nav .level_1 .active").toggleClass("menu_open")
      $(".submenu.trail").toggleClass("menu_open")
    }
    if($(".sw-nav .level_2").hasClass("active_submenu")) {
      $(".level_2.active_submenu").slideUp(250);
      $(".level_2.active_submenu").toggleClass("active_submenu")
    }
    $(".sw-nav .hover_background").stop().slideUp(500);
    if($(".sw-nav .hover_background").hasClass("menu_hovered")){
      $(".header-audio-player").toggleClass("hide-player")
      $(".sw-nav .hover_background").toggleClass("menu_hovered")
    }
    clearAllBodyScrollLocks();
  })

  $(".sw-nav .hover_background .hover_close").click(function() {
    $(".level_2.active_submenu").slideUp(250);
    $(".level_2.active_submenu").toggleClass("active_submenu")
    $(".sw-nav .hover_background").slideUp(500);
    $(".sw-nav .hover_background").toggleClass("hover_close_clicked")
    clearAllBodyScrollLocks();    
  })

    // Toggle mobile menu
  $(".sw-nav-toggle").click(function(e) {
    e.preventDefault();
    $(".mobile-navigation").slideDown(400);
    $(".mobile-navigation").toggleClass("toggled");

    targetElementTab = document.getElementsByClassName('mobile-navigation');
    // disableBodyScroll(targetElementTab);
  });

  $(".mobile-close").click(function(e) {
    e.preventDefault();
    $(".mobile-navigation").slideUp(400);
    $(".mobile-navigation").toggleClass("toggled");
    clearAllBodyScrollLocks();

  });

  // Close mobile menu when clicking anchor links (e.g. jodelsolo page)
  $(".mobile-navigation .anchor-link .level_1 > li > a[href*='#']").click(function() {
    $(".mobile-navigation").slideUp(400);
    if ($(".mobile-navigation").hasClass("toggled")) {
      $(".mobile-navigation").toggleClass("toggled");
    }
    clearAllBodyScrollLocks();
  });

  // Touch devices: Fake hover on touch with CSS class "touch_hover"
  $(".sw-nav ul.level_1 > li.submenu > a").bind("touchstart", function(e){
    e.preventDefault();
    $(this).parent().siblings("li").removeClass("touch_hover");
    $(this).parent().toggleClass("touch_hover");
  });

  $(".sw-nav ul.level_1 > li.submenu").mouseenter(function() {
    $(".active_parentmenu").toggleClass("active_parentmenu")
    $(this).toggleClass("active_parentmenu")
    if(!$(this).find(".level_2").hasClass("active_submenu")) {
      $(".level_2.active_submenu").slideUp(250);
      $(".level_2.active_submenu").toggleClass("active_submenu")
      $(this).find(".level_2").stop().slideDown(250);
      $(this).find(".level_2").toggleClass("active_submenu")
    }
  })

  $(document).on('click', function(e) {
    $(".navigation ul.level_1 > li").removeClass("touch_hover");
  });

 $(".mobile-navigation .sw-nav .level_2").click(function(e) {
    e.preventDefault();
    $(".mobile-navigation").toggleClass("toggled");
  });

  // Make active parent expanded
  $(".mobile-navigation ul.level_1 > li.active").addClass("expanded");
  $(".mobile-navigation ul.level_1 > li.trail").addClass("expanded");
  $(".mobile-navigation ul.level_1 li.expanded").children("ul.level_2").show();

  // Mobile nav: Remove "expanded" when something else is clicked
  $(".mobile-navigation.mobile-size ul.level_1 > li.submenu > a").click(function(e) {
    e.preventDefault();

    var clickedLi = $(this).parent();

    // Add class "expanded" to clicked element and remove it from the others
    $(clickedLi).toggleClass("expanded").siblings().removeClass("expanded");

    // If current element is expanded, slide down the menu. Else, slide it up (closing)
    if ($(clickedLi).hasClass("expanded")) {
      $(clickedLi).children("ul.level_2").stop().slideDown();
    } else {
      $(clickedLi).children("ul.level_2").stop().slideUp();
    }

    // Slide up other menus
    $(clickedLi).siblings().children("ul.level_2").slideUp();
  });

  $(".mobile-navigation.desktop-size ul.level_1 > li.submenu").mouseenter(function(e) {
    e.preventDefault();

    var clickedLi = $(this);

    // Add class "expanded" to clicked element and remove it from the others
    $(clickedLi).toggleClass("expanded").siblings().removeClass("expanded");

    // If current element is expanded, slide down the menu. Else, slide it up (closing)
    if ($(clickedLi).hasClass("expanded")) {
      $(clickedLi).children("ul.level_2").stop().slideDown(250);
    } else {
      $(clickedLi).children("ul.level_2").stop().slideUp(250);
    }

    // Slide up other menus
    $(clickedLi).siblings().children("ul.level_2").stop().slideUp(250);
  });

  $(".mobile-navigation ul.level_1 > li.submenu").mouseleave(function(e) {
    e.preventDefault();

    var clickedLi = $(this);
    $(clickedLi).children("ul.level_2").stop().slideUp(250);
    setTimeout(function() { 
      $(".expanded").toggleClass("expanded");
    }, 50);

    
  });

  // Anchor links: close mobile menu, let browser handle native hash navigation
  $('.level_2 a, .anchor-link a').click(function(){
    if($(".mobile-navigation").hasClass("toggled")){
      $(".mobile-navigation").slideUp(400);
      $(".mobile-navigation").toggleClass("toggled");
    }
    clearAllBodyScrollLocks();
  });

$(".hover_background .widget-text").click(function() {
  $(this).addClass("open_search");
  $(this).find("input").focus();
})

$(".sw-footer .widget-text").click(function() {
  $(this).addClass("open_search");
  $(this).find("input").focus();
})

$(".mobile-navigation .widget-text").click(function() {
  $(this).addClass("open_search");
  $(this).find("input").focus();
})

$(".top-button").click(function() {
  $("html, body").animate({ scrollTop: "0" });
})

// Fancybox lightbox for galleries (replaces MooTools Mediabox from Contao 4)
$('a[data-lightbox]').each(function() {
  var group = $(this).attr('data-lightbox');
  $(this).attr('data-fancybox', group);
});
if (typeof $.fancybox !== 'undefined') {
  $('[data-fancybox]').fancybox();
}

const swiper = new Swiper('.swiper', {
  slidesPerView: 1,
  simulateTouch: false,
  spaceBetween: 30,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
  },
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  breakpoints: {
      1234: {
          slidesPerView: 3
      },
      768: {
          slidesPerView: 2,
          simulateTouch: true
      }
  }
});

const swiperGallery = new Swiper('.swiper-gallery', {
  slidesPerView: 1,
  simulateTouch: false,
  // spaceBetween: 50,
  loop: true,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
  },
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  }
});

$(".sound-example").click(function() {
  if($(this).hasClass("play-example")) {
    $(this).toggleClass("play-example");
    $(this).toggleClass("paused-example");
    if($(this).parents(".klangbeispiele").find(".play-example").length !== 0 ) {
      $(this).toggleClass("muted-play")
      // $(this).find("audio")[0].prop("volume", 0);
      $(this).find("audio")[0].muted = true;
    }
    else {
      $(this).parents(".klangbeispiele").find(".sound-example").each(function() {
        $(this).toggleClass("muted-play");
        $(this).find("audio")[0].pause();
      })
      $(this).toggleClass("muted-play");
    }
  }
  else if($(this).hasClass("muted-play")) {
    $(this).toggleClass("play-example");
    $(this).toggleClass("muted-play");
    if($(this).hasClass("paused-example")) {
      $(this).toggleClass("paused-example");
    }
    // $(this).find("audio")[0].prop("volume", 1);
      $(this).find("audio")[0].muted = false;
  } else {
    stopAudioMixer();
    stopAudioSample();
    stopVideo();
    $(this).toggleClass("play-example");
    if($(this).hasClass("paused-example")) {
      $(this).toggleClass("paused-example");    
    }
    $(this).parents(".klangbeispiele").find(".sound-example").each(function() {
      $(this).toggleClass("muted-play");
      // $(this).find("audio")[0].prop("volume", 0);
      $(this).find("audio")[0].muted = true;
      $(this).find("audio")[0].play();
    })
    $(this).toggleClass("muted-play");
    // $(this).find("audio")[0].prop("volume", 1);
    $(this).find("audio")[0].muted = false;
  }
})

function stopAudioMixer() {
  if($(".audio-mixer .play-button.playing").length !== 0) {
    let audioMixer = $(".audio-mixer .play-button.playing").first();

    audioMixer.parents(".mixer-control").removeClass("playing");
    audioMixer.parents(".audio-mixer").find(".mixer-image-right").removeClass("playing");
    audioMixer.parents(".audio-mixer").find(".mixer-image-left").removeClass("playing");
    audioMixer.parents(".audio-mixer").find(".audio-source-left").find("audio")[0].pause();
    audioMixer.parents(".audio-mixer").find(".audio-source-right").find("audio")[0].pause();
    audioMixer.toggleClass("playing");
  }
}

function stopAudioSample() {
  if($(".digital-audio-container #play-icon.playing").length !== 0) {
    let audioSample = $(".digital-audio-container #play-icon.playing").first();

    audioSample.parent().find("audio")[0].pause();
    audioSample.parents(".digital-audio-container").removeClass("playing-track");
    audioSample.toggleClass("playing");
  }
}

function stopVideo() {
  if($(".is-playing").length !== 0) {
      let video = $(".is-playing");

      video.parents(".video_container").find("video")[0].pause()
      video.toggleClass("is-playing")
  }
}



if($( "#stick-image-right" ).length && $( "#stick-image-left" ).length){
  let siteHeight = $("#main").outerHeight();
  $(document).scroll(function() {
    let imageRightHeight = $("#stick-image-right").outerHeight();
    let imageLeftHeight = $("#stick-image-left").outerHeight();
    let posTop = $(document).scrollTop();
    // let posPer = Math.floor(posTop / siteHeight * 100)
    let posPer = posTop / siteHeight * 100
    let imageRightPosition = $( window ).height() - ((imageRightHeight + $( window ).height()) * ((posPer - 10) / 40))
    let imageLeftPosition = $( window ).height() - ((imageLeftHeight + $( window ).height()) * ((posPer - 50) / 40))
    if(posPer < 10) {
      if($("#stick-image-right").hasClass("show-image")) {
        $("#stick-image-right").removeClass("show-image");
      }
    }
    if(posPer >= 10 && posPer < 50) {
      if(!$("#stick-image-right").hasClass("show-image")) {
        $("#stick-image-right").addClass("show-image");
      }
      if($("#stick-image-left").hasClass("show-image")) {
        $("#stick-image-left").removeClass("show-image");
      }
      document.getElementById('stick-image-right').style.setProperty('--rightStickyImagePosition', imageRightPosition + 'px')
    }
    if(posPer >= 50 && posPer < 90) {
      if(!$("#stick-image-left").hasClass("show-image")) {
        $("#stick-image-left").addClass("show-image");
      }
      if($("#stick-image-right").hasClass("show-image")) {
        $("#stick-image-right").removeClass("show-image");
      }
      document.getElementById('stick-image-left').style.setProperty('--leftStickyImagePosition', imageLeftPosition + 'px')
    }
    if(posPer >= 90) {
      if($("#stick-image-left").hasClass("show-image")) {
        $("#stick-image-left").removeClass("show-image");
      }
    }
  })
}

if($( "#FirstImage" ).length && $( "#SecondImage" ).length){
  $(document).scroll(function() {
    let posTop = $(document).scrollTop();
    let containerHeight = $(".home-intro-section").outerHeight();
    let newPos = (((containerHeight * 0.42) + (posTop * 0.2)) / containerHeight * 100 );

    document.getElementById('FirstImage').style.setProperty('--imageOneHeight', newPos + '%');
    document.getElementById('SecondImage').style.setProperty('--imageTwoHeight', (100 - newPos) + '%');
    document.getElementById('SecondImage').style.setProperty('--imageOneHeight', newPos + '%');
  })
}

if($(".preview-bg-gradient").length){
  $(document).scroll(function() {
    let posTop = $(document).scrollTop();
    let startChange = $(".preview-bg-gradient").offset().top - $( window ).height();
    let containerHeight = $(".preview-bg-gradient").outerHeight();
    let viewHeight = $( document ). height();
  
    if(posTop > startChange) {
      let percentCont = Math.round((((posTop - startChange) / containerHeight) * 10) * 100 ) / 100;
      let newValue = 100 - percentCont;
      // document.getElementById('FirstImage').style.setProperty('--imageOneHeight', newPos + '%');
      $("body").get(0).style.setProperty('--gradientOne', newValue + '%');
    }
  })
}

$(".expand-text").click(function() {
  $(this).parent().find("p").toggleClass("show-text");
  if($(this).hasClass("hide-text")) {
    $(this).siblings(".hiding").toggleClass("hiding");
    $(this).toggleClass("show");
  }
  else {
    $(this).toggleClass("hiding");
    $(this).siblings(".hide-text").toggleClass("show");
  }
})

if($(".bg-slow-scroll").length) {
  $(document).scroll(function() {
    var scrolltotop = document.scrollingElement.scrollTop;
    var xvalue = "center";
    var factor = 0.35;

    // Handle each element individually
    $(".bg-slow-scroll .image-bg-container").each(function() {
      var $el = $(this);
      var position = $el.offset();
      var yvalue = (scrolltotop - position.top) * factor;
      // Limit parallax range to prevent image from moving too far
      yvalue = Math.max(-100, Math.min(100, yvalue));
      $el.css("background-position", xvalue + " " + yvalue + "px");
    });
  })
}

$(".open-publication").click(function(e) {
  e.preventDefault()
  $(this).toggleClass("open")
  $(".publication-table").toggleClass("show-all");
})

$(window).scroll( function(){
  $(".simplefadein").each( function(){
    let top_of_element = $(this).offset().top + 50;
    let bottom_of_window = $(window).scrollTop() + $(window).height();

    if(bottom_of_window >= top_of_element) {
      $(this).addClass("in-view");
    }
  })

  $('.fadeintitle').each( function(i){
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    // var moment_of_fadein = bottom_of_element + ($(window).height() / 2) - ($(this).outerHeight() / 2);
    var moment_of_fadein = bottom_of_element;
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 4);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
    }
    if( bottom_of_window >= moment_of_fadein && !$(this).hasClass("stay-in-view") ){
      $(this).addClass("is-in-view");
      $(this).addClass("sticky-element");
    }
    if( bottom_of_window > moment_of_fadeout ) {
      $(this).removeClass("is-in-view");
      $(this).addClass("stay-in-view");
    }
  });

  $('.fadeinleft').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    // var moment_of_fadein = bottom_of_element + ($(window).height() / 3) - ($(this).outerHeight() / 2);
    var moment_of_fadein = bottom_of_element + 100;
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 2);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).addClass("fadeout");
      // $(this).removeClass("is-activated")
    }
    if( bottom_of_window >= moment_of_fadein ){
      // $(this).addClass("is-in-view");
      if(!$(this).hasClass("is-activated")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("sticky-element")
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      // $(this).removeClass("is-in-view");
    }
  });

  $('.fadeinright').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    // var moment_of_fadein = bottom_of_element + ($(window).height() / 2) - ($(this).outerHeight() / 1);
    var moment_of_fadein = bottom_of_element - ($(this).outerHeight() / 2);
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 4);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).addClass("fadeout");
      // $(this).removeClass("is-activated")
    }
    if( bottom_of_window >= moment_of_fadein ){
      if(!$(this).hasClass("is-activated")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").addClass("stay-in-view")
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("sticky-element")
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      // $(this).removeClass("is-in-view");
      // $(this).addClass("fadeout");
    }
  });

  $('.fadeinright-late').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element + ($(window).height() / 2) - ($(this).outerHeight() / 2);
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 4);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).addClass("fadeout");
      // $(this).removeClass("is-activated")
    }
    if( bottom_of_window >= moment_of_fadein ){
      if(!$(this).hasClass("is-activated")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("sticky-element")
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
    }
  });

  $('.fadeinbottom').each( function(i){
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element - ($(this).outerHeight() * 0.2) + ($(window).height() / 3) - ($(this).outerHeight() / 2);
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 2);
    if( bottom_of_window < bottom_of_element ){
      // $(this).removeClass("is-in-view");
    }
    if( bottom_of_window >= moment_of_fadein ){
      $(this).addClass("is-in-view");
      $(this).removeClass("is-out-of-view");
      if($(".fadeinstickymiddle").hasClass("is-in-view")) {
        $(".fadeinstickymiddle").addClass("fadeout")
        setTimeout(function() {
          $(".fadeinstickymiddle").removeClass("is-in-view")
          $(".fadeinstickymiddle").removeClass("fadeout")
        }, 500);
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      $(this).addClass("is-out-of-view");
    }
  });

  $('.fadeinmiddle').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element + 100;
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 2);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).removeClass("is-activated");
    }
    if( bottom_of_window >= moment_of_fadein ){
      if(!$(this).hasClass("is-activated")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").addClass("stay-in-view")
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("is-activated")
            $(".sticky-element").removeClass("sticky-element")
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      // $(this).removeClass("is-in-view");
    }
  });

  $('.fadeinmiddle-late').each( function(i){
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element + ($(window).height() / 2) - ($(this).outerHeight() / 2);
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 4);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
    }
    if( bottom_of_window >= moment_of_fadein ){
      $(this).addClass("is-in-view");
    }
    if( bottom_of_window > moment_of_fadeout ) {
      // $(this).removeClass("is-in-view");
    }
  });

  $('.fadeinbox').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element + ($(window).height() / 3) - ($(this).outerHeight() / 2);
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 2);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).removeClass("is-activated");
    }
    if( bottom_of_window >= moment_of_fadein ){
      if(!$(this).hasClass("is-activated")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("is-activated")
            $(".sticky-element").removeClass("sticky-element")
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      // $(this).removeClass("is-in-view");
    }
  });

  $('.fadeinstickymiddle').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    // var moment_of_fadein = bottom_of_element + ($(window).height() / 3) - ($(this).outerHeight() / 2);
    var moment_of_fadein = bottom_of_element;
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 2);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).removeClass("is-activated")
      // $(this).removeClass("sticky-element");
    }
    if( bottom_of_window >= moment_of_fadein && bottom_of_window <= moment_of_fadeout ){
      if(!$(this).hasClass("is-activated") && !$(this).hasClass("stay-in-view")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          // $(".sticky-element").removeClass("is-activated")
          setTimeout(function() {
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("is-activated")
            $(".sticky-element").removeClass("sticky-element")
            $this.addClass("sticky-element");
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $(this).addClass("sticky-element");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      $(this).addClass("stay-in-view");
    }
  });

  $('.fadeinleadbox').each( function(i){
    var $this = $(this);
    var bottom_of_element = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height();
    var moment_of_fadein = bottom_of_element + 100;
    var moment_of_fadeout = moment_of_fadein + ($(window).height() / 3);
    if( bottom_of_window < moment_of_fadein ){
      // $(this).removeClass("is-in-view");
      // $(this).removeClass("is-activated")
      // $(this).removeClass("sticky-element");
    }
    if( bottom_of_window >= moment_of_fadein && bottom_of_window <= moment_of_fadeout ){
      if(!$(this).hasClass("is-activated") && !$(this).hasClass("stay-in-view")) {
        if($(".sticky-element").length) {
          $(".sticky-element").addClass("fadeout")
          setTimeout(function() {
            $(".sticky-element").addClass("stay-in-view")
            $(".sticky-element").removeClass("is-in-view")
            $(".sticky-element").removeClass("fadeout")
            $(".sticky-element").removeClass("is-activated")
            $(".sticky-element").removeClass("sticky-element")
            $this.addClass("sticky-element");
          }, 500);
          setTimeout(function() {
            $this.addClass("is-in-view");
            $this.removeClass("fadeout");
          }, 500);
        }
        else {
          $this.addClass("is-in-view");
          $this.removeClass("fadeout");
          $(this).addClass("sticky-element");
        }
        $(this).addClass("is-activated")
      }
    }
    if( bottom_of_window > moment_of_fadeout ) {
      $(this).addClass("stay-in-view");
    }
  });
});

if($(".shadow-container").length) {
  $(document).scroll(function() {
    if($(document).scrollTop() >= $(".shadow-container").offset().top) {
      $(".shadow-container").addClass("pos-fixed");
    }
    if($(document).scrollTop() <= $(".shadow-container").parent().offset().top) {
      $(".shadow-container").removeClass("pos-fixed");
    }
  })
}

if($(".box-animation").length) {
  let refernzenItems = $(".box-animation .col-lg-6")
  let activateAnimation = 0
  // var items = document.getElementsByClassName("fade-item");
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".box-animation").offset().top) && activateAnimation === 0) {
      window.innerHeight = 1
      for (let i = 0; i < refernzenItems.length; ++i) {
        fadeIn(refernzenItems[i], i * 150)
      }
    }
  })
}

if($(".mitarbeiter-grid").length) {
  let mitarbeiterItems = $(".mitarbeiter-grid .image_container")
  let activateAnimationMitarbeiter = 0
  if(($(window).scrollTop() + window.innerHeight - 200 >= $(".mitarbeiter-grid").offset().top) && activateAnimationMitarbeiter === 0) {
    for (let i = 0; i < mitarbeiterItems.length; ++i) {
      fadeIn(mitarbeiterItems[i], i * 150)
    }
    activateAnimationMitarbeiter = 1;
  }
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".mitarbeiter-grid").offset().top) && activateAnimationMitarbeiter === 0) {
      for (let i = 0; i < mitarbeiterItems.length; ++i) {
        fadeIn(mitarbeiterItems[i], i * 150)
      }
    }
  })
}

if($(".news-carousel").length) {
  let eventItems = $(".news-carousel .event")
  let activateAnimationEvents = 0
  if(($(window).scrollTop() + window.innerHeight - 200 >= $(".news-carousel").offset().top) && activateAnimationEvents === 0) {
    for (let i = 0; i < eventItems.length; ++i) {
      fadeIn(eventItems[i], i * 150)
    }
    activateAnimationEvents = 1
  }
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".news-carousel").offset().top) && activateAnimationEvents === 0) {
      window.innerHeight = 1
      for (let i = 0; i < eventItems.length; ++i) {
        fadeIn(eventItems[i], i * 150)
      }
    }
  })
}

if($(".tours-grid").length) {
  let tourItems = $(".tours-grid .kachel-image")
  let activateAnimationTours = 0
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".tours-grid").offset().top) && activateAnimationTours === 0) {
      for (let i = 0; i < tourItems.length; ++i) {
        fadeIn(tourItems[i], i * 150)
      }
    }
  })
}

if($(".occasions-grid").length) {
  let occasionsItems = $(".occasions-grid .kachel-image")
  let activateAnimationOccasions = 0
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".occasions-grid").offset().top) && activateAnimationOccasions === 0) {
      for (let i = 0; i < occasionsItems.length; ++i) {
        fadeIn(occasionsItems[i], i * 150)
      }
    }
  })
}

if($(".location-image").length) {
  let locationItems = $(".location-image")
  let activateAnimationLocation = 0
  $(document).scroll(function() {
    if(($(window).scrollTop() + window.innerHeight - 200 >= $(".location-image").offset().top) && activateAnimationLocation === 0) {
      for (let i = 0; i < locationItems.length; ++i) {
        fadeIn(locationItems[i], i * 150)
      }
    }
  })
}

function fadeIn (item, delay) {
  setTimeout(() => {
    item.classList.add('fadein')
  }, delay)
}

$('.full-shadow').each( function(i){
  let opacityValueLoading = 1;
  if(($(window).scrollTop() + window.innerHeight) < $(this).offset().top) {
    opacityValueLoading = 1;
  }
  if((($(window).scrollTop() + window.innerHeight) >= $(this).offset().top) && (($(window).scrollTop() + 110) < $(this).offset().top)) {
    opacityValueLoading = ($(this).offset().top - $(window).scrollTop() - 110) / (window.innerHeight - 110)
    jQuery(this).css({ opacity: opacityValueLoading });
  }
  if((($(window).scrollTop() + 110) >= $(this).offset().top)) {
    opacityValueLoading = 0
    jQuery(this).css({ opacity: opacityValueLoading });
  }
})
$(window).scroll( function(){
  $('.full-shadow').each( function(i){
    let opacityValue = 1;
    if(($(window).scrollTop() + window.innerHeight) < $(this).offset().top) {
      opacityValue = 1;
    }
    if((($(window).scrollTop() + window.innerHeight) >= $(this).offset().top) && (($(window).scrollTop() + 110) < $(this).offset().top)) {
      opacityValue = ($(this).offset().top - $(window).scrollTop() - 110) / (window.innerHeight - 110)
      jQuery(this).css({ opacity: opacityValue });
    }
    if((($(window).scrollTop() + 110) >= $(this).offset().top)) {
      opacityValue = 0
      jQuery(this).css({ opacity: opacityValue });
    }
  })
})

$(".expand-plus").click(function() {
  $(this).parents(".header-lead-text").toggleClass("expanded")
})

$(".hackbrett-hover-link").click(function(e) {
  e.preventDefault()
})

$(".hackbrett-hover-link").hover(function() {
  $(".hackbrett-hover-player").find("audio")[0].play();
}, function() {
  $(".hackbrett-hover-player").find("audio")[0].pause();
})

$(".glossar-link a").click(function(e) {
  e.preventDefault()
})

$(".search-results > div").click(function() {
  window.location.href = $(this).find("h3 a").attr('href');
})


}); // end document ready

$(window).resize(function() {
  if($(window).width() <= 1074 ) {
    $(".mobile-navigation").addClass("mobile-size");
  }else {
    $(".mobile-navigation").addClass("desktop-size");
  }
});

/* Schlanker MP3-Player (ce_player.html5 Override) — class-basiert, mehrere Instanzen pro Seite */
$(function () {
  var players = document.querySelectorAll('.sw-audio');
  if (!players.length) return;

  var formatTime = function (secs) {
    if (!isFinite(secs) || secs < 0) return '0:00';
    var m = Math.floor(secs / 60);
    var s = Math.floor(secs % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  };

  players.forEach(function (player) {
    var audio  = player.querySelector('.sw-audio__media');
    var toggle = player.querySelector('.sw-audio__toggle');
    var seek   = player.querySelector('.sw-audio__seek');
    var curEl  = player.querySelector('.sw-audio__current');
    var durEl  = player.querySelector('.sw-audio__duration');
    if (!audio || !toggle || !seek) return;

    var setFill = function () {
      var pct = seek.max > 0 ? (seek.value / seek.max) * 100 : 0;
      seek.style.setProperty('--sw-audio-fill', pct + '%');
    };
    var setDuration = function () {
      if (durEl) durEl.textContent = formatTime(audio.duration);
    };

    var raf = null;
    var render = function () {
      // Thumb nicht überschreiben, während der Nutzer zieht
      if (audio.duration > 0 && document.activeElement !== seek) {
        seek.value = (audio.currentTime / audio.duration) * seek.max;
        setFill();
      }
      if (curEl) curEl.textContent = formatTime(audio.currentTime);
    };
    var loop = function () {
      render();
      raf = requestAnimationFrame(loop);
    };
    var stopLoop = function () {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    };

    if (audio.readyState > 0) setDuration();
    audio.addEventListener('loadedmetadata', setDuration);

    toggle.addEventListener('click', function () {
      if (audio.paused) {
        // Nur eine sw-audio-Instanz gleichzeitig abspielen
        document.querySelectorAll('.sw-audio__media').forEach(function (other) {
          if (other !== audio && !other.paused) other.pause();
        });
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      player.classList.add('is-playing');
      toggle.setAttribute('aria-label', 'Pause');
      stopLoop();
      loop();
    });
    audio.addEventListener('pause', function () {
      player.classList.remove('is-playing');
      toggle.setAttribute('aria-label', 'Abspielen');
      stopLoop();
      render();
    });
    audio.addEventListener('ended', function () {
      stopLoop();
      audio.currentTime = 0;
      seek.value = 0;
      setFill();
      if (curEl) curEl.textContent = '0:00';
    });

    seek.addEventListener('input', function () {
      setFill();
      if (audio.duration > 0) {
        audio.currentTime = (seek.value / seek.max) * audio.duration;
        if (curEl) curEl.textContent = formatTime(audio.currentTime);
      }
    });

    setFill();
  });
});